import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { LatestPostResultsDto } from '../../../../../../common/general-types/super-social.dto';
import { SubmittedPostDto } from '../../../../../../common/general-types/submitted-posts.dto';
import { ImageService } from '../../../../../../services/image/image.service';
import { FormatService } from '../../../../../../common/format/format.service';

type EngagementPerformer = {
  handle: string;
  profilePic: string;
  engagementRate: number;
  views: number;
  videoLink: string;
  submittedPost: SubmittedPostDto;
};

type LikedPerformer = {
  handle: string;
  profilePic: string;
  views: number;
  likes: number;
  videoLink: string;
  submittedPost: SubmittedPostDto;
};

@Component({
  selector: 'mbtr-top-performers',
  standalone: true,
  imports: [],
  templateUrl: './top-performers.component.html',
  styleUrl: './top-performers.component.css'
})
export class TopPerformersComponent implements OnInit {

  @Input() postsList: any;
  @Output() jumpToContent = new EventEmitter<LatestPostResultsDto>();

  engagementPerformers = signal<EngagementPerformer[] | undefined>(undefined);
  viewedPerformers = signal<EngagementPerformer[] | undefined>(undefined);
  likedPerformers = signal<LikedPerformer[] | undefined>(undefined);

  superSocialResults = signal<LatestPostResultsDto[] | undefined>(undefined);


  /** Services */
  public imageService = inject(ImageService);
  public formatService = inject(FormatService);
  /** Services - END */

  ngOnInit(): void {
    console.log('🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨 TopPerformers -> postsList: ', this.postsList);

    this.superSocialResults.set([]);

    if (this.postsList) {
      Object.keys(this.postsList).forEach(postId => {
        const post = this.postsList[postId];
        this.superSocialResults.set([...this.superSocialResults()!, post]);
      });

      this.sortPerformers();
    }
  }

  sortPerformers() {
    const ranked = this.superSocialResults()!.filter((result) => result.submittedPost?.creator);

    this.engagementPerformers.set(ranked.sort((a, b) => Number(b.engagementRate) - Number(a.engagementRate)).map((result) => ({
      handle: result.handle,
      profilePic: result.submittedPost.creator!.photoURL,
      engagementRate: result.engagementRate,
      views: result.views,
      videoLink: result.submittedPost.videoLink,
      submittedPost: result.submittedPost,
    })).slice(0, 5));

    console.log('engagementPerformers', this.engagementPerformers);

    this.likedPerformers.set(ranked.sort((a, b) => b.likes - a.likes).map((result) => ({
      handle: result.handle,
      profilePic: result.submittedPost.creator!.photoURL,
      views: result.views,
      likes: result.likes,
      videoLink: result.submittedPost.videoLink,
      submittedPost: result.submittedPost,
    })).slice(0, 5));

    this.viewedPerformers.set(ranked.sort((a, b) => b.views - a.views).map((result) => ({
      handle: result.handle,
      profilePic: result.submittedPost.creator!.photoURL,
      engagementRate: result.engagementRate,
      views: result.views,
      videoLink: result.submittedPost.videoLink,
      submittedPost: result.submittedPost,
    })).slice(0, 5));
  }

  openPostInNewTab(videoLink: string) {
    window.open(videoLink, '_blank');
  }

  launchContentViewer(performer: { submittedPost: SubmittedPostDto }) {
    this.jumpToContent.emit({ submittedPost: performer.submittedPost } as LatestPostResultsDto);
  }
}
